import React, { ChangeEvent } from 'react'
import { NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper } from '@rockr/rock-ui'
import {mountEvent} from '../../shared/helpers/input'

type Props = {
  name: string
  disabled?: boolean
  value?: number
  onChange?: (e: ChangeEvent<any>) => any,
  isInvalid?: boolean
}

export const PercentInput: React.FC<Props> = ({
  name,
  disabled,
  value: defaultValue,
  onChange,
  isInvalid
}) => {
  const format = (val: any) => `${val.toFixed(2)}%`

  const [value, setValue] = React.useState((defaultValue || 0) * 100)

  const handleInputChange = (
    valueAsString: string,
    valueAsNumber: number
  ) => {
    setValue(valueAsNumber)
    const rawEvent = mountEvent(name, valueAsNumber / 100)
    onChange?.(rawEvent as ChangeEvent<any>)
  }

  return (
    <NumberInput
      step={.01}
      onChange={handleInputChange}
      value={format(value)}
      isDisabled={disabled}
      isInvalid={isInvalid}
    >
      <NumberInputField />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </NumberInput>
  );
}
